import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BankAccountService } from '../../../services/bankAccount.service';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { CardModule } from 'primeng/card';
import { DropdownModule } from 'primeng/dropdown';
import { InputNumberModule } from 'primeng/inputnumber';
import { CalendarModule } from 'primeng/calendar';

@Component({
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FormsModule, InputTextModule, ButtonModule, CardModule, DropdownModule, InputNumberModule, CalendarModule],
  selector: 'app-form-bank-account',
  templateUrl: './form-bank-account.component.html',
  styleUrls: ['./form-bank-account.component.css'],
  providers: [BankAccountService],
})
export class FormBankAccountComponent implements OnInit {
  form!: FormGroup;
  isEditMode = false;
  id?: number;

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private bankAccountService: BankAccountService
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      accountName: ['', Validators.required],
      initialBalance: [0, [Validators.required]],
      balanceDate: ['', Validators.required],
      active: [true, Validators.required],
    });

    this.id = Number(this.route.snapshot.paramMap.get('id'));
    if (this.id) {
      this.isEditMode = true;
      this.bankAccountService.find(this.id).subscribe({
        next: (response) => {
          if (response.data) {
            this.form.patchValue(response.data);
          }
        },
      });
    }
  }

  onSubmit() {
    if (this.form.invalid) return;
    const value = this.form.value;
    if (this.isEditMode && this.id) {
      value.id = this.id;
      this.bankAccountService.update(this.id, value).subscribe({
        next: () => this.router.navigate(['/app/financial/bank-accounts']),
      });
    } else {
      this.bankAccountService.create(value).subscribe({
        next: () => this.router.navigate(['/app/financial/bank-accounts']),
      });
    }
  }

  goBack() {
    this.router.navigate(['/app/financial/bank-accounts']);
  }
} 